/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface CopyShiftsData
 */
export interface CopyShiftsData {
    /**
     * 
     * @type {number}
     * @memberof CopyShiftsData
     */
    scheduleId: number;
    /**
     * 
     * @type {number}
     * @memberof CopyShiftsData
     */
    employeeId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyShiftsData
     */
    includes?: Array<CopyShiftsDataIncludesEnum>;
    /**
     * Where to start copying from (inclusive)
     * @type {Date}
     * @memberof CopyShiftsData
     */
    sourceStart: Date;
    /**
     * Where to finish copying (exclusive)
     * @type {Date}
     * @memberof CopyShiftsData
     */
    sourceEnd: Date;
    /**
     * Where to start copying to (inclusive)
     * @type {ShiftiePlainDate}
     * @memberof CopyShiftsData
     */
    targetStart: ShiftiePlainDate;
    /**
     * Where to finish copying to (inclusive)
     * @type {ShiftiePlainDate}
     * @memberof CopyShiftsData
     */
    targetEnd: ShiftiePlainDate;
    /**
     * Should each target day receive its shifts from a source day that is on the same day of the week as the target day?
     * @type {boolean}
     * @memberof CopyShiftsData
     */
    snapSourceToTargetWeekday?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CopyShiftsData
     */
    conflictMode: CopyShiftsDataConflictModeEnum;
    /**
     * 
     * @type {string}
     * @memberof CopyShiftsData
     */
    shiftConflictUnassignCondition: CopyShiftsDataShiftConflictUnassignConditionEnum;
}

/**
* @export
* @enum {string}
*/
export enum CopyShiftsDataIncludesEnum {
    Tags = 'tags',
    ScheduledBreaks = 'scheduledBreaks',
    ShiftAreaSessions = 'shiftAreaSessions'
}
/**
* @export
* @enum {string}
*/
export enum CopyShiftsDataConflictModeEnum {
    Omit = 'Omit',
    Overwrite = 'Overwrite',
    Unassign = 'Unassign',
    UnassignAll = 'Unassign All'
}
/**
* @export
* @enum {string}
*/
export enum CopyShiftsDataShiftConflictUnassignConditionEnum {
    WhenShiftsConflict = 'WhenShiftsConflict',
    WhenShiftsOrWorkPatternsConflict = 'WhenShiftsOrWorkPatternsConflict'
}


/**
 * Check if a given object implements the CopyShiftsData interface.
 */
export function instanceOfCopyShiftsData(value: object): value is CopyShiftsData {
    if (!('scheduleId' in value) || value['scheduleId'] === undefined) return false;
    if (!('sourceStart' in value) || value['sourceStart'] === undefined) return false;
    if (!('sourceEnd' in value) || value['sourceEnd'] === undefined) return false;
    if (!('targetStart' in value) || value['targetStart'] === undefined) return false;
    if (!('targetEnd' in value) || value['targetEnd'] === undefined) return false;
    if (!('conflictMode' in value) || value['conflictMode'] === undefined) return false;
    if (!('shiftConflictUnassignCondition' in value) || value['shiftConflictUnassignCondition'] === undefined) return false;
    return true;
}

export function CopyShiftsDataFromJSON(json: any): CopyShiftsData {
    return CopyShiftsDataFromJSONTyped(json, false);
}

export function CopyShiftsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyShiftsData {
    if (json == null) {
        return json;
    }
    return {
        
        'scheduleId': json['scheduleId'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'includes': json['includes'] == null ? undefined : json['includes'],
        'sourceStart': (new Date(json['sourceStart'])),
        'sourceEnd': (new Date(json['sourceEnd'])),
        'targetStart': ShiftiePlainDateFromJSON(json['targetStart']),
        'targetEnd': ShiftiePlainDateFromJSON(json['targetEnd']),
        'snapSourceToTargetWeekday': json['snapSourceToTargetWeekday'] == null ? undefined : json['snapSourceToTargetWeekday'],
        'conflictMode': json['conflictMode'],
        'shiftConflictUnassignCondition': json['shiftConflictUnassignCondition'],
    };
}

  export function CopyShiftsDataToJSON(json: any): CopyShiftsData {
      return CopyShiftsDataToJSONTyped(json, false);
  }

  export function CopyShiftsDataToJSONTyped(value?: CopyShiftsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scheduleId': value['scheduleId'],
        'employeeId': value['employeeId'],
        'includes': value['includes'],
        'sourceStart': ((value['sourceStart']).toISOString()),
        'sourceEnd': ((value['sourceEnd']).toISOString()),
        'targetStart': ShiftiePlainDateToJSON(value['targetStart']),
        'targetEnd': ShiftiePlainDateToJSON(value['targetEnd']),
        'snapSourceToTargetWeekday': value['snapSourceToTargetWeekday'],
        'conflictMode': value['conflictMode'],
        'shiftConflictUnassignCondition': value['shiftConflictUnassignCondition'],
    };
}

